import { render, staticRenderFns } from "./ConfigurationDocumentalPolicy.vue?vue&type=template&id=33587e6b&"
import script from "./ConfigurationDocumentalPolicy.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDocumentalPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports